"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var react_1 = __importDefault(require("react"));
var react_dates_1 = require("react-dates");
require("react-dates/initialize");
require("react-dates/lib/css/_datepicker.css");
var moment_1 = __importDefault(require("moment"));
function DateRangePicker(props) {
    return (react_1.default.createElement(react_dates_1.DayPickerRangeController, __assign({}, props, { isOutsideRange: function (day) {
            return (0, react_dates_1.isInclusivelyBeforeDay)(day, (0, moment_1.default)().add(-1, 'days'));
        } })));
}
exports.DateRangePicker = DateRangePicker;
//# sourceMappingURL=DateRangePicker.js.map